import { FadeUp, SectionLabel } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Intelligence First",
    body: "Every Veerox venture starts with intelligence at its core — AI employees that never sleep, trading systems that think before they trade, and software that learns your business.",
  },
  {
    num: "02",
    title: "Survive, Then Scale",
    body: "We don't optimize for quick wins. We optimize for surviving markets — Capital-First risk engines, battle-tested automation, and products trusted by 20,000+ users worldwide.",
  },
  {
    num: "03",
    title: "Beyond the Screen",
    body: "Veerox is more than code. From Dignity Food Kitchen to Being Food, we bring the same obsession with quality into the real world — real ingredients, real happiness.",
  },
  {
    num: "04",
    title: "One Group. Infinite Momentum.",
    body: "Six ventures, one engine. Shared technology, shared ambition, and a single promise stamped on everything we ship — Built for Success.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-36">
    <div className="pointer-events-none absolute right-0 top-40 h-96 w-96 rounded-full bg-blue-600/10 blur-[140px]" />
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <FadeUp>
        <SectionLabel>The Manifesto</SectionLabel>
      </FadeUp>
      <FadeUp delay={0.1}>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
          What drives the <span className="text-gradient-cyan">Veerox</span> engine.
        </h2>
      </FadeUp>

      <div className="mt-20 space-y-0">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.num} delay={i * 0.05}>
            <div
              data-testid={`manifesto-chapter-${c.num}`}
              className="group grid grid-cols-1 gap-6 border-t border-white/10 py-12 transition-colors duration-500 hover:border-cyan-400/30 md:grid-cols-[200px_1fr_1fr] md:gap-12"
            >
              <span className="font-mono-tech text-5xl font-semibold text-slate-700 transition-colors duration-500 group-hover:text-cyan-400 md:text-7xl">
                {c.num}
              </span>
              <h3 className="font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
                {c.title}
              </h3>
              <p className="max-w-xl text-base leading-relaxed text-slate-400 md:justify-self-end">
                {c.body}
              </p>
            </div>
          </FadeUp>
        ))}
        <div className="border-t border-white/10" />
      </div>
    </div>
  </section>
);
